import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Col, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import React, { Fragment, useEffect, useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  fetchCompanyFormList,
  fetchCountryList,
  fetchStoreFormList,
  registration,
} from "../../actions/security";
import { useDispatch, useSelector } from "react-redux";

import CheckIcon from "@mui/icons-material/Check";
import Header from "../../components/Header";
import { IconButton } from "@mui/material";
import { basicFormValidationHandler } from "../../utils";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import CustomModal from "../../components/Reusable/CustomModal";

const Registration = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [data, setData] = useState({
    name: "",
    lastName: "",
    email: "",
    password: "",
    countryId: 0,
    companyId: 0,
    rePassword: "",
    phone: "",
    city: "",
    address: "",
    accountType: "BASIC_USER",
    sector: "DEVICE_FOR_HOUSE",
    storeId: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };
  const handleToggleRePassword = () => {
    setShowRePassword((prev) => !prev);
  };

  const { companyFormList, countryFormList, storeFormList } = useSelector(
    (state) => state.loggedUserReducer
  );
  const [countryCode, setCountryCode] = useState("+381");
  const [errors, setErrors] = useState({});
  const [isChecked, setIsChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [passwordConditions, setPasswordConditions] = useState({
    uppercase: false,
    minLength: false,
    number: false,
    specialChar: false,
  });

  const handleCountryCodeChange = (event) => {
    setCountryCode(event.target.value);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setData((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));

    if (name === "countryId") {
      dispatch(fetchCompanyFormList(value));

      setData((prevUser) => ({
        ...prevUser,
        companyId: 0,
        storeId: "",
      }));
    }

    if (name === "companyId") {
      dispatch(fetchStoreFormList(value));
      setData((prevUser) => ({
        ...prevUser,
        storeId: "",
      }));
    }
  };

  useEffect(() => {
    dispatch(fetchCountryList());
  }, []);

  // Funkcija koja proverava uslove lozinke
  const validatePassword = (password) => {
    const uppercaseRegex = /[A-Z]/;
    const numberRegex = /\d/;
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;

    setPasswordConditions({
      uppercase: uppercaseRegex.test(password),
      minLength: password.length >= 8,
      number: numberRegex.test(password),
      specialChar: specialCharRegex.test(password),
    });
  };

  // Funkcija koja proverava da li su lozinke iste
  const handlePasswordChange = (event) => {
    handleInputChange(event);
    if (event.target.name === "password") {
      validatePassword(event.target.value);
    }
  };

  const clientValidationHandler = () => {
    const { name, lastName, email, countryId, companyId, storeId, phone } =
      data;
    const errorsObject = basicFormValidationHandler({
      name,
      lastName,
      email,
      countryId,
      companyId,
      storeId,
      phone,
    });
    setErrors(errorsObject);
    if (!isEmpty(errorsObject))
      toast.error("Morate popuniti sva obavezna polja", { theme: "colored" });
    return !isEmpty(errorsObject);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (clientValidationHandler()) {
      return;
    }

    if (!isChecked) {
      toast.error("Morate potvrditi uslove korišćenja!", { theme: "colored" });
      return;
    }

    if (data.password !== data.rePassword) {
      toast.error("Lozinke se ne podudaraju!", { theme: "colored" });
      return;
    }
    if (
      !passwordConditions.uppercase ||
      !passwordConditions.minLength ||
      !passwordConditions.number ||
      !passwordConditions.specialChar
    ) {
      toast.error(
        "Morate da unesete lozinku sa najmanje 8 karaktera, velikim slovom, brojem i specijalnim karakterom!",
        { theme: "colored" }
      );
      return;
    }

    const items = {
      name: data.name,
      lastName: data.lastName,
      email: data.email,
      password: data.password,
      countryId: data.countryId,
      companyId: data.companyId,
      storeId: data.storeId,
      accountType: data.accountType,
      sector: data.sector,
      city: data.city,
      address: data.address,
      phone: countryCode + data.phone,
    };

    dispatch(registration(items, navigate));
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
    !isChecked && setShowModal(true);
  };

  return (
    <Fragment>
      <Header nameClass="backgorund-color-header" />
      <div className="registration-main-container">
        <h3 className="text-center">{t("registration.title")}</h3>
        {/* <Link to="/login">Intro</Link> */}
        <form onSubmit={handleSubmit} noValidate>
          <Row>
            <Col xs={6}>
              <TextField
                required
                label={t("registration.name")}
                name="name"
                value={data.name}
                variant="standard"
                onChange={handleInputChange}
                fullWidth
                size="small"
                className="input-field-form"
              />
            </Col>
            <Col xs={6}>
              <TextField
                required
                label={t("registration.lastName")}
                variant="standard"
                name="lastName"
                value={data.lastName}
                onChange={handleInputChange}
                fullWidth
                size="small"
                className="input-field-form"
              />
            </Col>
            <Col xs={12}>
              <TextField
                type="email"
                variant="standard"
                required
                label={t("registration.email")}
                name="email"
                value={data.email}
                onChange={handleInputChange}
                fullWidth
                size="small"
                className="input-field-form"
              />
            </Col>
            <Col xs={7}>
              <TextField
                type="number"
                label={t("registration.phone")}
                className="input-field-form special-number-input"
                size="small"
                required
                name="phone"
                variant="standard"
                value={data.phone}
                onChange={handleInputChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Select
                        value={countryCode}
                        onChange={handleCountryCodeChange}
                        variant="standard"
                        size="small"
                        disableUnderline
                      >
                        <MenuItem value="+381">
                          <img src="/images/sr.png" alt="phone" />
                          +381
                        </MenuItem>
                        <MenuItem value="+385">
                          <img src="/images/hr.png" alt="phone" />
                          +385
                        </MenuItem>
                        <MenuItem value="+389">
                          <img src="/images/mk.png" alt="phone" />
                          +389
                        </MenuItem>
                        {/* <MenuItem value="+355">
                          <img src="/images/al.png" alt="phone" />
                          +355
                        </MenuItem> */}
                        {<MenuItem value="+386">
                          <img src="/images/sl.png" alt="phone" />
                          +386
                        </MenuItem> }
                        {/* <MenuItem value="+359">
                          <img src="/images/bg.png" alt="phone" />
                          +359
                        </MenuItem> */}
                        <MenuItem value="+387">
                          <img src="/images/ba.png" alt="phone" />
                          +387
                        </MenuItem>
                      </Select>
                    </InputAdornment>
                  ),
                }}
              />
            </Col>
            <Col xs={5}>
              <FormControl
                fullWidth
                className="mb-3"
                size="small"
                variant="standard"
              >
                <InputLabel id="demo-simple-select-label">
                  {t("registration.position")}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  variant="standard"
                  id="demo-simple-select"
                  value={data.accountType}
                  label="Pozicija"
                  name="accountType"
                  onChange={handleInputChange}
                  size="small"
                >
                  <MenuItem value="BASIC_USER">
                    {t("registration.prodavac")}
                  </MenuItem>
                  <MenuItem value="MANAGER">
                    {t("registration.manager")}
                  </MenuItem>
                </Select>
              </FormControl>
            </Col>
            <Col xs={12}>
              <FormControl
                fullWidth
                className="mb-3"
                size="small"
                variant="standard"
                required
              >
                <InputLabel id="demo-simple-select-label">
                  {t("registration.country")}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  variant="standard"
                  id="demo-simple-select"
                  value={data.countryId}
                  label={t("registration.country")}
                  name="countryId"
                  onChange={handleInputChange}
                  size="small"
                >
                  {countryFormList?.map((country) => (
                    <MenuItem value={country.id}>{country.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Col>
            <Col xs={12}>
              <FormControl
                fullWidth
                className="mb-3"
                size="small"
                variant="standard"
                required
                disabled={data.countryId === 0 && true}
              >
                <InputLabel id="demo-simple-select-label">
                  {t("registration.company")}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  variant="standard"
                  id="demo-simple-select"
                  value={data.companyId}
                  label={t("registration.company")}
                  name="companyId"
                  onChange={handleInputChange}
                  size="small"
                >
                  {companyFormList?.map((company) => (
                    <MenuItem value={company.id}>{company.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Col>
            <Col xs={6}>
              <FormControl
                fullWidth
                className="mb-3"
                size="small"
                variant="standard"
                required
                disabled={data.companyId === 0 && true}
              >
                <InputLabel id="demo-simple-select-label">
                  {t("registration.store")}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  variant="standard"
                  id="demo-simple-select"
                  value={data.storeId}
                  label={t("registration.store")}
                  name="storeId"
                  onChange={handleInputChange}
                  size="small"
                >
                  {storeFormList?.map((store) => (
                    <MenuItem value={store.id}>{store.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Col>

            <Col xs={6}>
              <FormControl
                fullWidth
                className="mb-3"
                size="small"
                variant="standard"
                required
              >
                <InputLabel id="demo-simple-select-label">
                  {t("registration.sector_name")}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  variant="standard"
                  id="demo-simple-select"
                  value={data.sector}
                  label={t("registration.sector_name")}
                  name="sector"
                  onChange={handleInputChange}
                  size="small"
                >
                  <MenuItem value="DEVICE_FOR_HOUSE">
                    {t("registration.sector_name_1")}
                  </MenuItem>
                  <MenuItem value="TV_AUDIO">
                    {t("registration.sector_name_2")}
                  </MenuItem>
                  <MenuItem value="DEVICE_FOR_HOUSE_AND_TV_AUDIO">
                    {t("registration.sector_name_3")}
                  </MenuItem>
                </Select>
              </FormControl>
            </Col>
            {/* <Col xs={12}>
              <TextField
                required
                label="Grad"
                variant="standard"
                name="city"
                value={data.city}
                onChange={handleInputChange}
                fullWidth
                size="small"
                className="input-field-form"
              />
            </Col>
            <Col xs={12}>
              <TextField
                required
                variant="standard"
                label="Adresa"
                name="address"
                value={data.address}
                onChange={handleInputChange}
                fullWidth
                size="small"
                className="input-field-form"
              />
            </Col> */}
            <Col xs={12}>
              <TextField
                type={showPassword ? "text" : "password"}
                variant="standard"
                required
                label={t("registration.password")}
                name="password"
                value={data.password}
                onChange={handlePasswordChange}
                fullWidth
                size="small"
                className="input-field-form"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleTogglePassword} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Col>
            <Col xs={12} className="passowrd-holder-item">
              <TextField
                type={showRePassword ? "text" : "password"}
                variant="standard"
                required
                label={t("registration.password_confirmation")}
                name="rePassword"
                value={data.rePassword}
                onChange={handleInputChange}
                fullWidth
                size="small"
                className="input-field-form"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleToggleRePassword} edge="end">
                        {showRePassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <div className="holder-password-required-items">
                <div className="info-password-required">
                  <div
                    className={`info-password-required-text ${
                      passwordConditions.uppercase
                        ? "check-required-success"
                        : ""
                    }`}
                  >
                    <CheckIcon /> {t("registration.info1")}
                  </div>
                  <div
                    className={`info-password-required-text ${
                      passwordConditions.minLength
                        ? "check-required-success"
                        : ""
                    }`}
                  >
                    <CheckIcon /> {t("registration.info2")}
                  </div>
                  <div
                    className={`info-password-required-text ${
                      passwordConditions.number ? "check-required-success" : ""
                    }`}
                  >
                    <CheckIcon /> {t("registration.info3")}
                  </div>
                  <div
                    className={`info-password-required-text ${
                      passwordConditions.specialChar
                        ? "check-required-success"
                        : ""
                    }`}
                  >
                    <CheckIcon /> {t("registration.info4")}
                  </div>
                </div>
              </div>
            </Col>
            <Col className="checkbox-form-registration">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isChecked}
                    onChange={(e) => handleCheckboxChange(e)}
                    size="small"
                    sx={{
                      color: "#c11f43",
                      "&.Mui-checked": {
                        color: "#c11f43",
                      },
                    }}
                  />
                }
                label={t("registration.confirm")}
              />
            </Col>
          </Row>

          <div className="button-registration-holder">
            <Button type="submit" fullWidth size="small">
              {t("registration.registruj_se")}
            </Button>
            <div className="registration-return-button-holder d-flex justify-content-between align-items-center">
              <div className="registration-return-button-login">
                <Link to="/login"> {t("login.prijava")}</Link>
              </div>
              <div className="registration-return-button-login">
                <Link to="/registration-code">
                  {t("registration.reg_code")}
                </Link>
              </div>
            </div>
          </div>
        </form>
      </div>
      {showModal && (
        <CustomModal show={showModal}>
          <div className="modal-popup-policy">
            <div
              className="modal-popup-policy-text"
              dangerouslySetInnerHTML={{
                __html: t("terms.content"),
              }}
            />
          </div>
          <div className="button-policy-registration-holder button-registration-holder">
            <button onClick={() => setShowModal(false)}>
              {t("registration.confirm")}
            </button>
          </div>
        </CustomModal>
      )}
    </Fragment>
  );
};

export default Registration;
